import React from 'react';

const ModalConditionsComponent = ({ show, handleClose, handleChoice }) => {


    return (
        <div className={`modal ${show ? 'd-block' : 'd-none'}`} tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Condições Gerais</h5>
                        <button type="button" className="btn-close custom-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleClose}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                fill="none"
                                viewBox="0 0 22 22"
                            >
                                <path
                                    fill="#005E2C"
                                    d="m22 2.832-8.164 8.18L22 19.168 19.189 22 11 13.845 2.836 22 0 19.168l8.189-8.156L0 2.832 2.836 0 11 8.18 19.189 0 22 2.832Z"
                                />
                            </svg>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="instruction-list">
                            <ul>
                                <li>- No dia da coleta, somente será retirado os itens listados no seu pedido.</li>
                                <li>- No caso de móveis, os itens devem estar desmontandos e prontos para serem retirados.</li>
                                <li>- O material deve passar facilmente pela porta principal e sem a necessidade de desmontagem.</li>
                                <li>- Não está incluso o içamento ou retirada do item pela janela.</li>
                                <li>- Na data, deve haver uma pessoa maior de 18 anos no local para acompanhar o serviço.</li>
                                <li>- Caso não consiga atender a equipe na data agendada, acesse o site e faça a alteração de data em até 24h antes do prazo de retirada.</li>
                                <li>- Em caso de cancelamento, você pode acessar o site e cancelar seu serviço em um prazo de até 24h antes da data da retirada. Se o cancelamento foi realizado no mesmo dia, poderemos reter uma parte do valor pago (25%) para cobrir os custos operacionais.</li>
                            </ul>
                        </div>
                       
                    </div>
                    <div className="modal-footer" style={{justifyContent:'center'}}>
                        <button type="button" className="button-terms" onClick={()=> handleChoice("C")}>Concordo</button>
                        <button type="button" className="button-terms" onClick={() => handleChoice("D")}>Discordo</button>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalConditionsComponent;
